import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { api, getToken, setToken, clearToken } from "@/lib/api";
import Auth from "@/components/Auth";
import Onboarding from "@/components/Onboarding";
import Shell from "@/components/Shell";

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null); // null = checking, false = not authed, obj = authed
  const [couple, setCouple] = useState(null);
  const [coupleLoading, setCoupleLoading] = useState(false);

  const loadMyCouple = async () => {
    setCoupleLoading(true);
    try {
      const { data } = await api.get("/me/couple");
      setCouple(data.couple);
    } catch {
      setCouple(null);
    } finally {
      setCoupleLoading(false);
    }
  };

  const checkAuth = async () => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadMyCouple();
    } catch {
      clearToken();
      setUser(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []); // eslint-disable-line

  const handleAuthed = async (data) => {
    setToken(data.token);
    setUser(data);
    await loadMyCouple();
  };

  const handleConnected = (data) => {
    setCouple(data);
  };

  const handleLogout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    clearToken();
    setUser(false);
    setCouple(null);
  };

  return (
    <div className="App min-h-screen bg-background text-foreground">
      <Toaster position="top-center" richColors />
      {user === null ? (
        <Spinner />
      ) : user === false ? (
        <Auth onAuthed={handleAuthed} />
      ) : coupleLoading ? (
        <Spinner />
      ) : !couple ? (
        <Onboarding onConnected={handleConnected} onLogout={handleLogout} />
      ) : (
        <Shell
          couple={couple}
          slot={couple.slot}
          refreshCouple={loadMyCouple}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
}

export default App;
